import { gql } from 'apollo-angular';

const UPDATE_CONTACT_INFO = gql`
  mutation updateUserContactInfo(
    $userId: Long!
    $contactInfo: ContactInfoRequest!
  ) {
    updateUserContactInfo(
      updateContactInfoRequest: { userId: $userId, contactInfo: $contactInfo }
    ) {
      id
      firstName
      lastName
      emailAddress
      jobTitle
      mobilePhone
      fax
    }
  }
`;

export default UPDATE_CONTACT_INFO;
